import { Checkbox } from 'antd';

const HVCheckbox = ({ helpers, meta, value, ...props }) => {
    // Ant doesn't like it when you pass a bool for value;
    // It only wants checked.
    // Prevents a warning.
    return <Checkbox {...props} checked={value} />;
};

export default HVCheckbox;
